var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appHome"},[_c('router-view'),(_vm.backShow)?_c('div',{staticClass:"backTop",on:{"click":_vm.backTop}},[_c('img',{attrs:{"src":require("./assets/backTop.png"),"alt":""}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }